<template>
  <div id="app">
    <Header
      v-if="!$route.meta.hideHeader"
      :showPenalties="showPenalties"
      :wsStatus="wsStatus"
      @open-modal="modal = $event"
    />

    <main>
      <router-view
        :modal="modal"
        @modal-status="modal = $event"
        @ws-change="wsStatus = $event"
        @show-penalties="showPenalties = $event"
      />
    </main>

    <Footer v-if="!$route.meta.hideFooter" />

    <CookieInfo />
  </div>
</template>

<script>
import Header from "@/components/Header.vue"
import Footer from "@/components/Footer.vue"
import CookieInfo from "@/components/CookieInfo.vue"

export default {
  components: {
    Header,
    Footer,
    CookieInfo,
  },

  metaInfo: {
    title: "Relacja na żywo z imprez motorsportowych",
    titleTemplate: "%s | wyniki-online.pl",
    htmlAttrs: {
      lang: "pl",
    },
  },

  data: () => ({
    showPenalties: false,
    wsStatus: false,
    modal: null,
  }),
}
</script>

<style lang="scss">
@import "@/scss/_body";

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  animation: fadeIn 250ms;
}

.page {
  animation: fadeIn 250ms;
}

.has-modal-active {
  overflow: hidden;
}
</style>
